import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import concursos from "./modules/concursos";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {

    },
    mutations: {

    },
    actions: {

    },

    modules: {
        auth,
        concursos,
    }
});